// mesma regra do Usuario::isCampTecnologia da API

const EMAIL_CAMP_TECNOLOGIA = /@camptecnologia\.com(\.br)?$/;

export const emailCampTecnologia = (email?: string | null): boolean =>
  EMAIL_CAMP_TECNOLOGIA.test(String(email ?? "").trim().toLowerCase());

export const usuarioCampTecnologia = (
  usuario: { codNivel?: number | string; email?: string | null } | null | undefined
): boolean => Number(usuario?.codNivel) === -1 && emailCampTecnologia(usuario?.email);
